<template>
  <div class="event-card-container">
		<div class="event-card" :data-id="payload['objectID']">
			<a class="event-card__inner" :href="`/event/${payload['slug']}`">
				<div class="event-card__header" :style="`background-image: url(${payload['cover-image']});`">
					<span v-if="!payload['in-person']" class="pill bg-blue-light" >Online</span>
					<span v-if="payload['in-person'] && payload['location'] !== ''" class="pill bg-blue-dark">
						<svg class="pill-icon fill-current text-pink" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 13"><path d="M4.305.894c-5.312.63-4.21 5.748-4.21 5.748l1.869 3.05L4.6 12.902 8.69 7.527c.512-.866.551-3.011.551-3.011C8.79.933 4.305.894 4.305.894zm.216 6.87c-2.066.059-2.302-2.461-2.302-2.461.197-2.087 2.066-2.283 2.597-2.283h.138c2.813.236 2.223 2.736 2.223 2.736-.374 1.85-2.066 2.027-2.518 2.027-.099-.02-.138-.02-.138-.02z"/></svg>
						{{ payload['location'] }}
					</span>
				</div>
				<div class="event-card__body">
					<h4 class="event-card__body-title">{{ payload['title'] }}</h4>
					<div class="event-card__body-group">
						<div class="event-card__body-group-date">
							<div class="icon-wrapper">
								<img class="icon" :src="`/images/icons/events/clock.svg?${$config.version}`" alt="Event Date and Time" loading="lazy" />
							</div>
							{{ $filters.ukDateTime(payload['event-date']) }}
						</div>
					</div>
					<p class="event-card__body-text">{{ payload['headline'] }}</p>
				</div>
				<div class="event-card__footer bg-grey">
					<div class="event-card__footer-img-wrapper">
						<img class="event-card__footer-img" :src="payload['logo']" alt="Organisation Name" loading="lazy" onerror="this.onerror=null; this.src='/images/fallback.png'">
					</div>
					<div class="event-card__footer-group">
						<p class="event-card__footer-name">
							<a href="/events?q=">{{ payload['institution'] }}</a>
						</p>
					</div>
					<template v-if="payload['cost'] !== undefined">
						<div v-if="payload['cost'] > 0" class="event-card__footer-price bg-blue-pale">
							<p class="text-blue-light">£{{ payload['cost'] }}</p>
						</div>
						<div v-if="payload['cost'] == 0" class="event-card__footer-price bg-green-pale">
							<p class="text-green">Free</p>
						</div>
					</template>
				</div>
			</a>
		</div>
	</div>
</template>

<script>
export default {
  props: {
    payload: {
      type: Object
    }
  }
};
</script>
